module.exports = __webpack_public_path__ + "img/felc-BFA赛区.2a7a25c9.png";